import React, { useContext, useEffect, useRef, useState } from "react";
import URLstateContext from "../../../provider/CommonContext";
import "./../../Navs/LatestNav/LatestNav.css";
import "./GetInTouch.css";

import {
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";

import "leaflet/dist/leaflet.css";
import { Col, Row, Form } from "react-bootstrap";
// import { Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross1 } from "react-icons/rx";
import animation from "../../../images/jm-animation.gif";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

import RenderLoading from "./RenderLoading";
import axios from "axios";

function GetInTouch() {
  //Upload Documents States
  const documentsInputRef = useRef(null); //Updated
  const [queryDoc, setQueryDoc] = useState(null); //Updated
  const [queryDocName, setQueryDocName] = useState(""); //Updated
  const [documentError, setDocumentError] = useState(""); //Updated
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  //-------------------------Below Updated Code-----------------------------------------------

  const [dropDownError, setDropDownError] = useState(""); // updated code
  const [dropDownErrorPartner, setDropDownErrorPartner] = useState(""); // updated code
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptionPartner, setSelectedOptionPartner] = useState("");

  //   ----------------------------------------------------------------------
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  const [activeButton, setActiveButton] = useState("investor");
  const [data, setData] = useState("");
  const [dataform, setDataForm] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [insertedfrom, setInsertedfrom] = useState("investor");
  const [distubutorcode, setDistubutorcode] = useState("");

  const [partnerActive, setPartnerActive] = useState(false);
  const [investorActive, setInvestorActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // const [investorSelection, setInvestorSelection] = useState("");
  // const [partnerSelection, setPartnerSelection] = useState("");
  //----------------------------------------------------------------

  //email states
  const [valueEmail, setValueEmail] = useState("");
  const [valueEmailPartner, setValueEmailPartner] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailErrorPartner, setEmailErrorPartner] = useState("");

  //Name States
  const [valueName, setValueName] = useState("");
  const [valueNamePartner, setValueNamePartner] = useState("");
  const [nameErrorPartner, setNameErrorPartner] = useState("");
  const [nameError, setNameError] = useState("");

  //Mobile Number States
  const [valueMob, setValueMob] = useState("");
  const [valueMobPartner, setValueMobPartner] = useState("");
  const [mobErrorPartner, setMobErrorPartner] = useState("");
  const [mobError, setMobError] = useState("");

  //City States
  const [valueCity, setValueCity] = useState("");
  const [cityError, setCityError] = useState("");
  const [zone, setzone] = useState("");
  const [citys, setCitys] = useState("");
  const [DataCities, setDataCities] = useState([]);
  const [DataCitiesdrop, setDataCitis] = useState([]);
  const [isCityShown, setIsCityShown] = useState(false);

  //Comments States
  const [valueComments, setValueComments] = useState("");
  const [valueCommentsPartner, setValueCommentsPartner] = useState("");
  const [CommentsErrorPartner, setCommentsErrorPartner] = useState("");
  const [CommentsError, setCommentsError] = useState("");

  //Captcha States
  const [CaptchaErrorPartner, setCaptchaErrorPartner] = useState("");
  const [CaptchaError, setCaptchaError] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaInputPartner, setCaptchaInputPartner] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");

  //ARN States
  const [ARNError, setARNError] = useState("");
  const [valueArn, setvalueArn] = useState("");

  //States for Partner Form and Investor Form
  const [showPartnerForm, setShowPartnerForm] = useState(false);
  const [showInvestorForm, setShowInvestorForm] = useState(true);


  const options = [
    "Services",
    "Investment",
    "CyberSecurity",
    "Fraudulent Transaction Intimation",
    "Grievances",
    "Others",
  ];

  useEffect(() => {
    generateCaptcha();
  }, [activeButton]);

  const generateCaptcha = () => {
    const canvas = document.getElementById("captcha");
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const canvas1 = document.getElementById("captcha");
    const ctx1 = canvas1.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let captchaCode = "";

    const minRotation = -45;
    const maxRotation = 45;
    const rotationRange = maxRotation - minRotation;

    const minFontSize = 20;
    const maxFontSize = 30;
    const fontSizeRange = maxFontSize - minFontSize;

    for (let i = 0; i < 6; i++) {
      const randomCharacter = characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
      captchaCode += randomCharacter;
      const fontSize = minFontSize + Math.random() * fontSizeRange;
      ctx.font = `${fontSize}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      const textColor = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, ${Math.floor(Math.random() * 256)})`;
      ctx.fillStyle = textColor;
      const rotation = minRotation + Math.random() * rotationRange;
      ctx.translate(20 + i * 30, canvas.height / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.fillText(randomCharacter, 0, 0);
      ctx.rotate((-rotation * Math.PI) / 180);
      ctx.translate(-(20 + i * 30), -canvas.height / 2);
    }
    setCaptchaCode(captchaCode);
  };

  // ===============================Upload File ======================================
  const validateFile = (file) => {
    const allowedTypes = [
      "application/pdf",
      "application/docx",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!allowedTypes.includes(file.type)) {
      let doc_err = setDocumentError(
        "Please upload only PDF, DOCX, or Excel files"
      );
      return false;
    }
    setDocumentError(""); // reset the error after valixdate
    return true;
  };


  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagtion();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagtion();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setQueryDoc(file);
      setQueryDocName(file.name);
    }
  };

  //   const handleDropDownChange = (e) => {
  //     setSelectedOption(e.target.value);
  //     setDropDownError("");
  //   };

  //Remove the document files
  const handleRemoveFile = (e) => {
    setQueryDoc(null);
    setQueryDocName("");
    setDocumentError("");
    setFileInputKey(Date.now());
  };
  const handleClick = () => {
    documentsInputRef.current.click();
  };
  // =================================== Upload File End =========================

  const handleRefreshClick = () => {
    generateCaptcha();
  };

  //Handle the Investor Button afer Click
  const handleInvestorButtonClick = () => {
    handleRemoveFile();
    setActiveButton("investor");
    setInsertedfrom("investor");
    setShowInvestorForm(true);
    setShowPartnerForm(false);
    generateCaptcha();
    setCaptchaInput("");
    clearFormFields("investor");
    setPartnerActive(false);
    setInvestorActive(true);
    // setSelectedOption(investorSelection); // Reset dropdown
    setIsOpen(false);
    setNameError("");
    setMobError("");
    setEmailError("");
    setDropDownError(""); // updated
    setDocumentError(""); //updated code
    setCaptchaError("");
    setCommentsError("");
  };

  //Handle the Partner Button after Click
  const handlePartnerButtonClick = () => {
    handleRemoveFile();
    setActiveButton("distributer");
    setInsertedfrom("distributer");
    setShowInvestorForm(false);
    setShowPartnerForm(true);
    clearFormFields("distributer");
    setPartnerActive(true);
    setInvestorActive(false);
    // setSelectedOption(partnerSelection); // Reset dropdown
    setIsOpen(false);
    setNameError("");
    setMobError("");
    setEmailError("");
    setCaptchaError("");
    setDropDownError("");
    setDocumentError(""); //updated code
    setCommentsError("");
    generateCaptcha();
    setCaptchaInput("");
    // setCaptchaInput('');
    // window.location.reload(true);
  };

  //--------------------------reset the Input value after switching the tab Start  --------------------------------
  const clearFormFields = (formType) => {
    if (formType === "investor") {
      setValueEmail("");
      setValueName("");
      setValueMob("");
      setValueComments("");
      setDropDownError("");
      setSelectedOption("");
      setEmailError("");
      setNameError("");
      setMobError("");
      setCommentsError("");
    } else if (formType === "distributer") {
      setValueEmailPartner("");
      setValueNamePartner("");
      setValueMobPartner("");
      setDropDownErrorPartner("");
      setSelectedOptionPartner("");
      setvalueArn("");
      setValueCity("");
      setValueCommentsPartner("");
      setEmailErrorPartner("");
      setNameErrorPartner("");
      setMobErrorPartner("");
      setARNError("");
      setCommentsErrorPartner("");
      setCityError("");
    }
  };
  //------------------------------------------reset the Input value after switching the tab End --------------------

  // ------------------------Handle the DropDownError------------------------
  const handleDropDownChange = (e) => {
    setSelectedOption(e.target.value);
    setDropDownError("");
  };

  const handleDropDownChangePartner = (e) => {
    setSelectedOptionPartner(e.target.value);
    setDropDownErrorPartner("");
  };

  useEffect(() => {
    GetPostMethodData(BaseURL + "GetCityState", {
      IVcity: valueCity,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataCities(DecryptAESdata(data.data));
      }
    });
  }, [BaseURL, valueCity]);
  let cityOptions = [];

  if (Array.isArray(DataCitiesdrop)) {
    cityOptions = DataCitiesdrop.map(({ city }) => ({
      value: city,
      label: city,
    }));
  }

  const getDistinctCities = () => {
    return DataCitiesdrop.reduce((uniqueCities, city) => {
      if (!uniqueCities.includes(city.city)) {
        uniqueCities.push(city.city);
      }
      return uniqueCities;
    }, []);
  };

  cityOptions = getDistinctCities().map((city) => ({
    value: city,
    label: city,
  }));
  cityOptions.unshift({ value: "", label: "All Cities" });

  //HANDLE THE INPUT VALUE OF USERS

  const handleName = (event) => {
    let regex = /^[A-Za-z\s]*$/;
    if (regex.test(event.target.value)) {
      setValueName(event.target.value);
    }
    if (event.target.value.length == 0) {
      setValueName("");
    }
    setNameError("");
    // setNameErrorPartner("");
  };
  const handleNamePartner = (event) => {
    let regex = /^[A-Za-z\s]*$/;
    if (regex.test(event.target.value)) {
      setValueNamePartner(event.target.value);
    }
    if (event.target.value.length == 0) {
      setValueNamePartner("");
    }
    // setNameError("");
    setNameErrorPartner("");
  };
  const handleEmail = (event) => {
    setValueEmail(event.target.value);
    setEmailError("");
    // setemailErrorPartner("");
  };
  const handleEmailPartner = (event) => {
    setValueEmailPartner(event.target.value);
    // setEmailError("");
    setEmailErrorPartner("");
  };
  const handleMobile = (event) => {
    const reMob = /^[0-9\b]+$/;
    if (reMob.test(event.target.value)) {
      setValueMob(event.target.value);
    }
    if (event.target.value.length == 0) {
      setValueMob("");
    }
    setMobError("");
    // setMobErrorPartner("");
  };
  const handleMobilePartner = (event) => {
    const reMob = /^[0-9\b]+$/;
    if (reMob.test(event.target.value)) {
      setValueMobPartner(event.target.value);
    }
    if (event.target.value.length == 0) {
      setValueMobPartner("");
    }
    // setMobError("");
    setMobErrorPartner("");
  };
  const handlecomment = (event) => {
    setValueComments(event.target.value);
    setCommentsError("");
    // setCommentsErrorPartner("");
  };
  const handlecommentPartner = (event) => {
    setValueCommentsPartner(event.target.value);
    // setCommentsError("");
    setCommentsErrorPartner("");
  };
  const handleCity = (event) => {
    setValueCity(event.target.value);
    // setValue(event.target.value);
    setCityError("");
    if (event.target.value !== "") {
      setIsCityShown(true);
    } else {
      setIsCityShown(false);
    }
  };

  const handaleARN = (event) => {
    setvalueArn(event.target.value);
    setARNError("");
  };
  const handleInputChange = (event) => {
    setCaptchaInput(event.target.value);
    setCaptchaError("");
    // setCaptchaErrorPartner('');
  };
  const handleInputChangePartner = (event) => {
    setCaptchaInputPartner(event.target.value);
    // setCaptchaError('');
    setCaptchaErrorPartner("");
  };

  //Submit Button method for Investor Form
  const submitGetInTouch = async (event) => {
    event.preventDefault();
    let errors = {};
    let isValid = true;
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (activeButton === "investor") {
      if (!valueName.trim()) {
        errors.nameError = "Please Enter Your Name";
        isValid = false;
      }
      if (selectedOption == "") {
        errors.dropDownError = "Please select a request from the list to continue.";
        isValid = false;
      }
      if (!valueEmail.trim()) {
        errors.emailError = "Please Enter Email Address";
        isValid = false;
      } else if (!regex.test(valueEmail)) {
        errors.emailError = "Please enter a valid email address in the format name@example.com.";
        isValid = false;
      }
      if (!valueMob.trim()) {
        errors.mobError = "Please Enter Mobile Number";
        isValid = false;
      } else if (valueMob.length !== 10) {
        errors.mobError = "Please enter a valid 10-digit mobile number using digits only.";
        isValid = false;
      }
          if (!valueComments.trim()) {
        errors.commentsError =
          "Please enter your comments or query. Describe your request so we can assist you.";
        isValid = false;
      } else if (valueComments.trim().length < 10) {
        errors.commentsError =
          "Please enter at least 10 characters so we can understand your query.";
        isValid = false;
      }
      //below updated code
      // if (!queryDoc) {
      //   errors.documentError = "Please Upload Your Documents";
      //   isValid = false;
      //   // setQueryDoc("");
      //   // setValueDocuments("")
      // }
      if (captchaInput === "") {
        errors.captchaError = "Please Enter Captcha";
        isValid = false;
      } else if (captchaInput !== captchaCode) {
        errors.captchaError = "Invalid Captcha Code";
        isValid = false;
        generateCaptcha();
        setCaptchaInput("");
      }
    }

    if (!isValid) {
      setDropDownError(errors.dropDownError || "");
      setDropDownErrorPartner(errors.dropDownErrorPartner || "");
      setNameError(errors.nameError || "");
      setEmailError(errors.emailError || "");
      setMobError(errors.mobError || "");
      setCommentsError(errors.commentsError || "");
      setNameErrorPartner(errors.nameErrorPartner || "");
      setEmailErrorPartner(errors.emailErrorPartner || "");
      setMobErrorPartner(errors.mobErrorPartner || "");
      setCommentsErrorPartner(errors.commentsErrorPartner || "");
      setARNError(errors.arnError || "");
      setCityError(errors.cityError || "");
      setCaptchaError(errors.captchaError || "");
      setDocumentError(errors.documentError || ""); // updated
      setCaptchaErrorPartner(errors.CaptchaErrorPartner || "");
      return;
    }

    setShowModal(true);

    try {
      // Prepare the data to be sent in the POST request
      const formData = new FormData();
      if (queryDoc) {
        formData.append("formFile", queryDoc); // The file input
        formData.append("fileName", queryDocName);

        // alert(resumeName);

        // Upload resume file
        await axios
          .post(BaseURL + "GetDocument", formData)
          .then((response) => {
          })
          .catch((error) => {
            if (error.response) {
              console.error("Server Error:", error.response.data);
            } else if (error.request) {
              console.error("No Response:", error.request);
            } else {
              console.error("Request Error:", error.message);
            }
            throw error; // Re-throw the error to stop further execution
          });
      } else {
      }

      const response = await GetPostMethodData(BaseURL + "GetInTouch", {
        IVemailid: valueEmail,
        IVinsertedfrom: insertedfrom,
        IVdistubutorcode: valueArn,
        IVname: valueName,
        IVmobile: valueMob,
        IVcity: valueCity,
        IVstate: "",
        IVquery: valueComments,
        FileName: selectedOption,
        selectedOption:
          "https://www.jmfinancialmf.com/CMS/getintouch/" + queryDocName,
        // IVdoc : setQueryDoc
      });

      const data = response.data;

      if (data != null && data.length > 0) {
        setShowModal(false);
        setData(DecryptAESdata(data));
        alert(
          "Thank you for reaching out. We will be in contact with you soon."
        );
        // toast.success(
        //   "Thank you for reaching out. We will be in contact with you soon."
        // );
        generateCaptcha();
        setValueName("");
        setValueEmail("");
        setValueMob("");
        setValueComments("");
        setvalueArn("");
        setValueCity("");
        setQueryDoc("");
        setSelectedOption("");
        // setCaptchaInputPartner("");
        setCaptchaInput("");
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setShowModal(false);
    }
  };

  //Submit Button method for Partner Form
  const submitPartnerButton = async (event) => {
    event.preventDefault();
    let errors = {};
    let isValid = true;
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (activeButton === "distributer") {
      if (!valueNamePartner.trim()) {
        errors.nameErrorPartner = "Please Enter Your Name";
        isValid = false;
      }
      if (selectedOptionPartner == "") {
        errors.dropDownErrorPartner = "Please Select a Request";
        isValid = false;
      }
      if (!valueEmailPartner.trim()) {
        errors.emailErrorPartner = "Please Enter Email Address";
        isValid = false;
      } else if (!regex.test(valueEmailPartner)) {
        errors.emailErrorPartner = "Please enter a valid email address in the format name@example.com.";
        isValid = false;
      }
      if (!valueMobPartner.trim()) {
        errors.mobErrorPartner = "Please Enter Mobile Number";
        isValid = false;
      } else if (valueMobPartner.length !== 10) {
        errors.mobErrorPartner = "Please enter a valid 10-digit mobile number using digits only.";
        isValid = false;
      }
      if (!valueCommentsPartner.trim()) {
      errors.commentsErrorPartner =
        "Please enter your comments or query. Describe your request so we can assist you.";
      isValid = false;
    } else if (valueCommentsPartner.trim().length < 10) {
      errors.commentsErrorPartner =
        "Please enter at least 10 characters so we can understand your request.";
      isValid = false;
    }
      if (!valueArn.trim()) {
        errors.arnError = "Please enter your ARN (AMFI Registration Number).";
        isValid = false;
      }
      if (!valueCity.trim()) {
        errors.cityError = "Please select your city from the available options.";
        isValid = false;
      }
      //below updated code
      // if (!queryDoc) {
      //   errors.documentError = "Please Upload Your Documents";
      //   isValid = false;
      // }
      if (captchaInputPartner === "") {
        errors.CaptchaErrorPartner = "Please Enter Captcha";
        isValid = false;
      } else if (captchaInputPartner !== captchaCode) {
        errors.CaptchaErrorPartner = "Invalid Captcha Code";
        isValid = false;
        generateCaptcha();
        setCaptchaInput("");
      }
    }

    if (!isValid) {
      setNameError(errors.nameError || "");
      setEmailError(errors.emailError || "");
      setDropDownError(errors.dropDownError || "");
      setDropDownErrorPartner(errors.dropDownErrorPartner || "");
      setMobError(errors.mobError || "");
      setCommentsError(errors.commentsError || "");
      setNameErrorPartner(errors.nameErrorPartner || "");
      setEmailErrorPartner(errors.emailErrorPartner || "");
      setMobErrorPartner(errors.mobErrorPartner || "");
      setCommentsErrorPartner(errors.commentsErrorPartner || "");
      setARNError(errors.arnError || "");
      setCityError(errors.cityError || "");
      setDocumentError(errors.documentError || ""); //updated
      setCaptchaError(errors.captchaError || "");
      setCaptchaErrorPartner(errors.CaptchaErrorPartner || "");
      return;
    }

    setShowModal(true);

    try {
      // Prepare the data to be sent in the POST request
      const formData = new FormData();
      if (queryDoc) {
        formData.append("formFile", queryDoc); // The file input
        formData.append("fileName", queryDocName);

        // alert(resumeName);

        // Upload resume file
        await axios
          .post(BaseURL + "GetDocument", formData)
          .then((response) => {
          })
          .catch((error) => {
            if (error.response) {
              console.error("Server Error:", error.response.data);
            } else if (error.request) {
              console.error("No Response:", error.request);
            } else {
              console.error("Request Error:", error.message);
            }
            throw error; // Re-throw the error to stop further execution
          });
      } else {
      }

      const response = await GetPostMethodData(BaseURL + "GetInTouch", {
        IVemailid: valueEmailPartner,
        IVinsertedfrom: insertedfrom,
        IVdistubutorcode: valueArn,
        IVname: valueNamePartner,
        IVmobile: valueMobPartner,
        IVcity: valueCity,
        IVstate: "",
        IVquery: valueCommentsPartner,
        FileName: selectedOptionPartner,
        selectedOption: "http://cmotswebnew:715/CMS/getintouch/" + queryDocName,
      });

      const data = response.data;

      if (data != null && data.length > 0) {
        setShowModal(false);
        setData(DecryptAESdata(data));
        alert(
          "Thank you for reaching out. We will be in contact with you soon."
        );
        // toast.success(
        //   "Thank you for reaching out. We will be in contact with you soon."
        // );
        generateCaptcha();
        setValueNamePartner("");
        setValueEmailPartner("");
        setValueMobPartner("");
        setValueCommentsPartner("");
        setvalueArn("");
        setValueCity("");
        setQueryDoc("");
        setSelectedOptionPartner("");
        // setCaptchaInput("");
        setCaptchaInputPartner("");
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Get all elements with the class "action-button"
  var actionButtons = document.querySelectorAll(".action-button");

  // Loop through each action button and add a click event listener
  actionButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      // Toggle the "active" class on the clicked element
      this.classList.toggle("active");
    });
  });

  //useEffect for File size validating and remove the file if it is too large
  useEffect(() => {
    const Max_File_Size = 2 * 1024 * 1024;
    if (!queryDoc) {
      return;
    }

    if (Max_File_Size < queryDoc.size) {
      alert("File Size Is Too Large");
      handleRemoveFile();
    }
  }, [queryDoc]);
  //--------------------------------------------------

  return (
    <>
      {showModal && <RenderLoading />}
      <div className="get-in-touch-section">
        <h2>Get In Touch</h2>

        {/* <div className="d-flex justify-content-end" style={{ marginBottom: "19px" }}> */}
        {/* <>
                    <Container>
                        <div className="branch-button">
                            <button className={activeButton === "investor" ? 'active' : ""} value="investor" onClick={(event) => { handleInvestorButtonClick(event.target.value) }}>Investor</button>
                            <button className={activeButton === "distributer" ? 'active' : ""} value="distributer" onClick={(event) => { handlePartnerButtonClick(event.target.value) }}>Partner</button>
                        </div>
                    </Container>
                </> */}
        {/* </div> */}

        {showInvestorForm && (
          <form action="">
            <div className="get-in-touch-container">
              <div className="get-in-touch-left">
                <div className="question-box">
                  <p>
                    {" "}
                    Kindly fill in your details, and we will get in touch with
                    you.
                  </p>
                </div>
                <div className="add-container">
                  <h2 className="add-head">Corporate Office</h2>
                  <div className="name">JM Financial Mutual Fund</div>
                  <p className="add">
                    One International Centre, 22nd Floor, Tower 2, Senapati Bapat Marg, Prabhadevi, Mumbai – 400013.
                  </p>
                  <div className="tel">
                    <span>Toll Free No.:</span> 1800 1038 345
                  </div>
                  <div className="tel mt-2">
                    <span>Fax No.:</span> + 91 (022) 6198 7704
                  </div>
                </div>
              </div>
              <div className="get-in-touch-right">
                <div className="branch-button">
                  <div className="investor-button">
                    <div>
                      <button
                        className={activeButton === "investor" ? "active" : ""}
                        value="investor"
                        onClick={(event) => {
                          handleInvestorButtonClick(event.target.value);
                        }}
                        aria-label="investor tab"
                      >
                        Investor
                      </button>
                    </div>

                    <div>
                      <button
                        className={
                          activeButton === "distributer" ? "active" : ""
                        }
                        value="distributer"
                        onClick={(event) => {
                          handlePartnerButtonClick(event.target.value);
                        }}
                        aria-label="partner tab"
                      >
                        Partner
                      </button>
                    </div>
                  </div>
                </div>

                {/*=========================== DROPDOWN FOR QUERY START  ============================*/}

                <div className="form-group-conatainer">
                  <div className="form-group">
                    <label htmlFor="raise-request">
                      Raise A Request<span aria-hidden="true">*</span>
                    </label>
                    <Form.Group
                      className="mb-3 row"
                      // controlId="department-location"
                    >
                      <div className="col-12">
                        <Form.Select
                          id="raise-request"
                          value={selectedOption}
                          onChange={handleDropDownChange}
                          aria-required="true"
                          autoComplete="off"
                        >
                          <option value="">Select A Request</option>
                          {/* <label value="">Raise A Request<span className="important-option">*</span> </label> */}
                          {options &&
                            Array.isArray(options) &&
                            options.length > 0 &&
                            options.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                        </Form.Select>

                        <span>
                          {dropDownError !== "" && (
                            <div className="GetError">{dropDownError}</div>
                          )}
                        </span>
                      </div>
                    </Form.Group>

                    <p className="dropdown-note">
                      {" "}
                      NOTE : For quick resolution on Service/ Investment / Cyber
                      Security/ Fraudulent transaction intimation / Grievances
                      provide PAN, Folio, Transaction ID details in comments
                      section
                    </p>
                  </div>
                </div>

                {/*=========================== DROPDOWN FOR QUERY END  ============================*/}

                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name<span aria-hidden="true">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder="Enter Your Name"
                      value={valueName}
                      onChange={handleName}
                      maxLength={100}
                      autoComplete="name"
                      required
                    />
                    <span>
                      {nameError !== "" && (
                        <div className="GetError">{nameError}</div>
                      )}
                    </span>
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email<span aria-hidden="true">*</span>
                    </label>
                    <input
                      id="email"
                      type="text"
                      placeholder="Enter Email ID"
                      value={valueEmail}
                      onChange={handleEmail}
                      maxLength={100}
                      autoComplete="email"
                      required
                    />
                    {emailError !== "" && (
                      <div className="GetError">{emailError}</div>
                    )}
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="phone">
                      Phone Number<span aria-hidden="true">*</span>
                    </label>
                    <input
                      id="phone"
                      type="text"
                      placeholder="Enter Mobile No"
                      value={valueMob}
                      maxLength="10"
                      onChange={handleMobile}
                      autoComplete="tel"
                      required
                    />
                    {mobError !== "" && (
                      <div className="GetError">{mobError}</div>
                    )}
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="comments">
                      Your Comments / Query<span aria-hidden="true">*</span>
                    </label>
                    <textarea
                      id="comments"
                      type="text"
                      value={valueComments}
                      placeholder="Type here..."
                      onChange={handlecomment}
                      autoComplete="off"
                      required
                    >
                      {" "}
                      Type here
                    </textarea>
                    {CommentsError !== "" && (
                      <div className="GetError">{CommentsError}</div>
                    )}
                  </div>
                </div>

            <Row>
  <Col sm={12}>
    <div
      style={{
        border: documentError
          ? "dashed 1px red"
          : "dashed 1px #3FB9D1",
        textAlign: "center",
        padding: "10px",
        fontSize: "13px",
      }}
      className={`form-group document-dropzone ${
        documentError ? "is-invalid" : ""
      }`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      {/* Proper label associated with the file input */}
      <label htmlFor="query-document">
        Upload Query Documents
      </label>

      <input
        id="query-document"
        type="file"
        key={fileInputKey}
        name="queryDocument"
        accept=".pdf,.docx,.xls,.xlsx"
        onChange={handleChange}
        style={{ display: "none" }}
        ref={documentsInputRef}
        className="visually-hidden-file-input"
        aria-describedby="query-document-help"
      />

      <div className="dotted-box">
        {queryDoc ? (
          <div>
            <strong>{queryDocName}</strong>

            <RxCross1
              onClick={handleRemoveFile}
              style={{
                cursor: "pointer",
                marginLeft: "10px",
              }}
              aria-label="Remove uploaded document"
            />
          </div>
        ) : (
          <span>
            Drop your document here or click to upload
          </span>
        )}
      </div>
    </div>

    {documentError && (
      <div
        className="GetError"
        style={{
          marginBottom: "8px",
          color: "black",
          fontSize: "13px",
        }}
      >
        {documentError}
      </div>
    )}

    {/* Instruction associated with the input */}
    <p
      id="query-document-help"
      style={{
        textAlign: "center",
        marginTop: "3px",
        color: "#B00020",
        fontSize: "13px",
      }}
    >
      (.pdf, .docx, .xls, .xlsx only)
    </p>
  </Col>
</Row>

                <div className="mb-3 d-flex align-items-center">
                  <canvas id="captcha" width="200" height="80"></canvas>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    id="refresh-captcha"
                    onClick={handleRefreshClick}
                    aria-label="refresh button"
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
                <div className="mb-3">
                  <label htmlFor="captcha-input" className="form-label">
                    Enter Captcha<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="captcha-input"
                    required
                    value={captchaInput}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                  {CaptchaError !== "" && (
                    <div className="GetError">{CaptchaError}</div>
                  )}
                </div>
                <div className="btn-submit-getin">
                  <Button
                    variant="contained"
                    className="btn-submit-getin"
                    onClick={submitGetInTouch}
                    aria-label="submit button"
                  >
                    Submit
                  </Button>
                </div>
                {loadingshow && (
                  <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                )}
              </div>
            </div>
          </form>
        )}

        {showPartnerForm && (
          <form action="">
            <div className="get-in-touch-container">
              <div className="get-in-touch-left">
                <div className="question-box">
                  {/* <div className="question-box-head">Still have questions</div> */}
                  <p>
                    Kindly fill in your details, and we will get in touch with
                    you.
                  </p>
                </div>
                <div className="add-container">
                  <div className="add-head">Corporate Office</div>

                  <div className="name">JM Financial Mutual Fund</div>
                  <p className="add">
                    One International Centre, 22nd Floor, Tower 2, Senapati Bapat Marg, Prabhadevi, Mumbai – 400013.
                  </p>

                  <div className="tel">
                    <span>Toll Free No.:</span> 1800 1038 345
                  </div>
                  <div className="tel mt-2">
                    <span>Fax No.:</span> + 91 (022) 6198 7704
                  </div>
                </div>
              </div>

              <div className="get-in-touch-right">
                <div className="branch-button">
                  <div className="investor-button">
                    <div>
                      <button
                        className={activeButton === "investor" ? "active" : ""}
                        value="investor"
                        onClick={(event) => {
                          handleInvestorButtonClick(event.target.value);
                        }}
                        aria-label="investor tab"
                      >
                        Investor
                      </button>
                    </div>

                    <div>
                      <button
                        className={
                          activeButton === "distributer" ? "active" : ""
                        }
                        value="distributer"
                        onClick={(event) => {
                          handlePartnerButtonClick(event.target.value);
                        }}
                        aria-label="partner tab"
                      >
                        Partner
                      </button>
                    </div>
                  </div>
                </div>
                {/* ------------------------------------------Drop Down Start------------------------------- */}
                <div className="form-group-conatainer">
                  <div className="form-group">
                    <label htmlFor="">
                      Raise A Request<span>*</span>
                    </label>
                    <Form.Group
                      className="mb-3 row"
                      // controlId="department-location"
                    >
                      <div className="col-12">
                        <Form.Select
                          // name="department"
                          value={selectedOptionPartner}
                          onChange={handleDropDownChangePartner}
                        >
                          <option value="">Select A Request</option>
                          {options &&
                            Array.isArray(options) &&
                            options.length > 0 &&
                            options.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))}
                        </Form.Select>
                        <span>
                          {dropDownErrorPartner !== "" && (
                            <div className="GetError">
                              {dropDownErrorPartner}
                            </div>
                          )}
                        </span>
                      </div>
                    </Form.Group>
                    <p className="dropdown-note">
                      {" "}
                      NOTE : For quick resolution on Service/ Investment / Cyber
                      Security/ Fraudulent transaction intimation / Grievances
                      provide PAN, Folio, Transaction ID details in comments
                      section
                    </p>
                  </div>
                </div>
                {/* -------------------------------------DropDown End ---------------------------- */}
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name<span aria-hidden="true">*</span>
                    </label>
                    {/* <input type="text" name="" id="" placeholder="Enter your name" /> */}

                    <input
                      id="name"
                      type="text"
                      placeholder="Enter Your Name"
                      value={valueNamePartner}
                      onChange={handleNamePartner}
                      maxLength={100}
                      required
                    />
                    <span>
                      {nameErrorPartner != "" && (
                        <div className="GetError">{nameErrorPartner}</div>
                      )}
                    </span>
                    {/* <span id='name-inp'>Exist</span> */}
                  </div>
                </div>

                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="email">
                      Email<span aria-hidden="true">*</span>
                    </label>
                    <input
                      id="email"
                      type="text"
                      placeholder="Enter Email ID"
                      value={valueEmailPartner}
                      onChange={handleEmailPartner}
                      maxLength={100}
                      required
                    />
                    {emailErrorPartner !== "" && (
                      <div className="GetError">{emailErrorPartner}</div>
                    )}
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="phone">
                      Phone Number<span>*</span>
                    </label>
                    <input
                      id="phone"
                      type="text"
                      placeholder="Enter Mobile No"
                      value={valueMobPartner}
                      maxLength="10"
                      onChange={handleMobilePartner}
                      required
                    />
                    <span>
                      {mobErrorPartner != "" && (
                        <div className="GetError">{mobErrorPartner}</div>
                      )}
                    </span>
                  </div>
                </div>

                <div className="form-group-container">
                  <div className="form-group">
                    <label for="">
                      ARN Number<span>*</span>
                    </label>
                    <div className="arn-input">
                      {/* <div className="arn-prefix">ARN-</div> */}
                      <span>ARN-</span>
                      <input
                        type="text"
                        maxLength="6"
                        defaultValue="ARN-"
                        value={valueArn}
                        onChange={handaleARN}
                        placeholder="Enter ARN number"
                      />
                    </div>
                    {ARNError != "" && (
                      <div className="GetError">{ARNError}</div>
                    )}
                  </div>
                </div>
                <div className="Branch-type-box">
                  <label>
                    {" "}
                    City<span>*</span>{" "}
                  </label>
                  <select onChange={handleCity} id="select-City-branch">
                    <option value=""> Select City </option>
                    {DataCities &&
                      DataCities.map(({ cityname }) => (
                        <option
                          value={cityname}
                          selected={valueCity === cityname}
                        >
                          {" "}
                          {cityname}{" "}
                        </option>
                      ))}
                  </select>
                  <span>
                    {cityError != "" && (
                      <div className="GetError">{cityError}</div>
                    )}
                  </span>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <label htmlFor="comments">
                      Your Comments / Query<span aria-hidden="true">*</span>
                    </label>
                    <textarea
                      id="comments"
                      type="text"
                      value={valueCommentsPartner}
                      placeholder="Type here..."
                      onChange={handlecommentPartner}
                      required
                    >
                      {" "}
                      Type here
                    </textarea>
                    <span>
                      {CommentsErrorPartner != "" && (
                        <div className="GetError">{CommentsErrorPartner}</div>
                      )}
                    </span>
                  </div>
                </div>

                <Row>
                  <Col sm={12}>
                    <div
                      style={{
                        border: documentError
                          ? "dashed 1px red"
                          : "dashed 1px #3FB9D1",
                        textAlign: "center",
                        padding: "10px",
                        fontSize: "13px",
                      }}
                      className={`form-group document-dropzone ${
                        documentError ? "is-invalid" : ""
                      }`}
                      onDragOver={handleDragOver}
                      onDrop={handleDrop}
                      onClick={handleClick}
                    >
                      <label>
                        Upload Query Documents{" "}
                      </label>
                      <input
                        type="file"
                        key={fileInputKey}
                        name="queryDocument"
                        accept=".pdf,.docx,.xls,.xlsx"
                        onChange={handleChange}
                        style={{ display: "none" }}
                        ref={documentsInputRef}
                      />
                      <div className="dotted-box">
                        {queryDoc ? (
                          <div>
                            <strong>{queryDocName}</strong>
                            <RxCross1
                              onClick={handleRemoveFile}
                              style={{
                                cursor: "pointer",
                                marginLeft: "10px",
                              }}
                            />
                          </div>
                        ) : (
                          <span>
                            Drop your document here or click to upload
                          </span>
                        )}
                      </div>
                    </div>
                    {documentError && (
                      <div
                        className="GetError"
                        style={{
                          marginBottom: "8px",
                          color: "black",
                          fontSize: "13px",
                        }}
                      >
                        {documentError}
                      </div>
                    )}
                    <label style={{ textAlign: "center", marginTop: "3px" }}>
                      <span style={{ color: "red", fontSize: "13px" }}>
                        (.pdf, .docx, .xls, .xlsx only)
                      </span>
                    </label>
                  </Col>
                </Row>
                <div className="mb-3 d-flex align-items-center">
                  <canvas id="captcha" width="200" height="80"></canvas>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    id="refresh-captcha"
                    onClick={handleRefreshClick}
                    aria-label="refresh button"
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
                <div className="mb-3">
                  <label htmlFor="captcha-input" className="form-label">
                    Enter Captcha<span aria-hidden="true">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="captcha-input"
                    required
                    value={captchaInputPartner}
                    onChange={handleInputChangePartner}
                  />

                  {CaptchaErrorPartner != "" && (
                    <div className="GetError">{CaptchaErrorPartner}</div>
                  )}
                </div>
                {/* <button className="button" onClick={submitGetInTouch}>Submit</button> */}
                <div className="btn-submit-getin">
                  <Button
                    className="btn-submit-getin"
                    onClick={submitPartnerButton}
                  >
                    Submit
                  </Button>
                </div>
                {loadingshow ? (
                  <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </form>
        )}
      </div>
    </>
  );
}

export default GetInTouch;
